import React from 'react'

export enum UserRole {
  ApplicationManager = 'All Employees',
  Manager = 'Executives',
  KeyUser = 'Admin'
}

interface PortalContextProps {
  openDrawer: boolean
  setOpenDrawer: (isOpen: boolean) => void
  drawerContent: string
  setDrawerContent: (content: string) => void
  drawerData: any
  setDrawerData: (data: any) => void
  toast: boolean
  setToast: (isOpen: boolean) => void
  toastContent: string
  setToastContent: (content: string) => void
  accessToken: string
  setAccessToken: (accessToken: string) => void
  loading: boolean
  setLoading: (isLoading: boolean) => void
  openModal: boolean
  setOpenModal: (isOpen: boolean) => void
  openModalExport: boolean
  setOpenModalExport: (isOpen: boolean) => void
  contentTitle: string
  setContentTitle: (content: string) => void
  modalData: any
  setModalData: (modalData: any) => void
  modalHeadlines: any
  setModalHeadlines: (modalHeadlines: any) => void
  userRole: UserRole
  setUserRole: (userRole: UserRole) => void
  error: boolean
  setError: (error: boolean) => void
}

export const PortalContext = React.createContext<PortalContextProps>({
  openDrawer: false,
  setOpenDrawer: () => {},
  drawerContent: '',
  setDrawerContent: () => {},
  drawerData: {},
  setDrawerData: () => {},
  toast: false,
  setToast: () => {},
  toastContent: '',
  setToastContent: () => {},
  accessToken: '',
  setAccessToken: () => {},
  loading: false,
  setLoading: () => {},
  openModal: false,
  setOpenModal: () => {},
  openModalExport: false,
  setOpenModalExport: () => {},
  contentTitle: '',
  setContentTitle: () => {},
  modalData: [],
  setModalData: () => {},
  modalHeadlines: [],
  setModalHeadlines: () => {},
  userRole: UserRole.ApplicationManager,
  setUserRole: () => {},
  error: false,
  setError: () => {}
})
